<template>
  <div
    class="relative z-30 rounded-full cursor-crosshair size-4 overflow-visible group"
  >
    <span
      class="absolute rounded-full pointer-events-none -inset-1.5"
      aria-hidden="true"
    />
    <span
      class="block w-full h-full transition-all border-2 rounded-full shadow-sm pointer-events-none border-n-slate-7 bg-n-solid-1 group-hover:scale-110 group-hover:border-n-blue-9 group-hover:bg-n-blue-9 group-hover:shadow-md group-hover:shadow-n-blue-5/35"
    />
  </div>
</template>
